module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/step_02.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2Fstep_02.jpg
// module id = GF0u
// module chunks = 93